<div class="container" [ngClass]="{ 'container-summary': isSummary }">
  <div class="text-container" *ngIf="!isFinland">
    <p class="text-left">{{ "personalInfo.borrower" | translate }}:</p>
    <p class="text-right">
      {{ personalInfoService.firstName + " " + personalInfoService.lastname }}
    </p>
  </div>
  <div class="text-container">
    <p class="text-left">{{ "personalInfo.business" | translate }}:</p>
    <p class="text-right">{{ basicInfoService.company.companyName }}</p>
  </div>
  <div class="text-container">
    <p class="text-left">{{ "personalInfo.amount" | translate }}:</p>
    <p class="text-right">
      {{ basicInfoService.amount | myCurrency }}
    </p>
  </div>
  <div class="text-container" *ngIf="basicInfoService.ticketType !== 'BIG'">
    <p class="text-left">{{ "personalInfo.period" | translate }}:</p>
    <p class="text-right">{{ basicInfoService.duration | duration: translate.instant('global.yearLabel') : translate.instant('global.monthLabel') }}</p>
  </div>
  <div class="text-container">
    <p class="text-left">{{ "personalInfo.email" | translate }}:</p>
    <p class="text-right">{{ basicInfoService.email }}</p>
  </div>
  <div class="text-container">
    <p class="text-left">{{ "personalInfo.phoneNumber" | translate }}:</p>
    <p class="text-right">{{ basicInfoService.phoneNumber }}</p>
  </div>
</div>
